import Box from '@mui/material/Box';
import { t } from 'i18next';
import { EmptyResource, isErrorStatus, isLoadingStatus, useResource } from 'json-api-hooks';
import React, { FC } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import Collection from '../../../components/./Collection/Collection';
import CardContent from '../../../components/Card/CardContent';
import CardMain from '../../../components/Card/CardMain';
import Container from '../../../components/Container';
import ErrorPage from '../../../components/Error/ErrorPage';
import Heading from '../../../components/Heading';
import { LoadingPage } from '../../../components/Loading';
import AddressTable from '../../../models/addresses/AddressTable';

const StreetShow: FC = () => {
  const { id } = useParams();
  const identifier: EmptyResource<'streets'> = { type: 'streets', id: id! };
  const [street, status] = useResource(identifier);
  const [pending, setPending] = React.useState(true);

  if (isLoadingStatus(status)) {
    return <LoadingPage />;
  }

  if (isErrorStatus(status) || !street) {
    return <ErrorPage status={status} />;
  }

  return (
    <Container>
      <CardMain>
        <CardContent>
          <Heading>{street.attributes.name}</Heading>
          <p>{t('street.description')}</p>
          <p>
            <span>
              {'Postcodegebied: '}
              {street.attributes.postalDigits.map((postalDigit) => (
                <Box
                  component="span"
                  key={postalDigit}
                  sx={{
                    display: 'inline-block',
                    marginRight: '0.3em',
                  }}
                >
                  <Link to={`/postal_codes/${postalDigit}`}>{postalDigit}</Link>
                </Box>
              ))}
            </span>
          </p>
        </CardContent>
      </CardMain>
      <Collection opts={{ filter: { streetId: [street.id], pending: [pending.toString()] } }} resourceType="addresses">
        <AddressTable pending={pending} setPending={setPending} />
      </Collection>
    </Container>
  );
};

export default StreetShow;
